<template>
  <div class="page-default">
    <div class="map-section">
      <div class="dashboard-map">
        <div class="map-body">
          <div class="mouseTrigger">
            <div class="map-filter-defects">
              <div class="dropdown-group">
                <div class="dropdown">
                  <button
                    class="btn btn-sm position-relative fs-8"
                    :class="currentDistrict ? 'btn-primary' : 'btn-light'"
                    type="button"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    data-placement="top"
                    aria-haspopup="true"
                    aria-expanded="false"
                    title="Filter by District"
                    @mouseover="helper.showTooltip"
                    @mouseleave="helper.hideTooltip"
                  >
                    <span>
                      <font-awesome-icon :icon="['fas', 'filter']" />
                      <font-awesome-icon
                        :icon="['fas', 'check-circle']"
                        class="text-success bg-white rounded-circle"
                        style="
                          font-size: 0.85em;
                          position: absolute;
                          top: 0.25em;
                          right: 0.25em;
                        "
                        v-if="currentDistrict"
                      />
                    </span>
                  </button>
                  <div
                    class="dropdown-menu p-0"
                    aria-labelledby="dropdownMenuButton"
                    style="max-height: 200px; overflow-y: auto"
                  >
                    <button
                      class="dropdown-item font-weight-medium btn-secondary d-flex justify-content-between align-items-center py-2 px-3 border-outline-light-bottom fs-8"
                      :class="currentDistrict != null ? '' : 'text-primary'"
                      @click="currentDistrict = null"
                    >
                      All districts
                      <font-awesome-icon
                        :icon="['fas', 'check']"
                        class="text-primary ml-3 small"
                        v-if="currentDistrict == null"
                      />
                    </button>
                    <button
                      v-for="district in districts"
                      :key="district._id"
                      class="dropdown-item py-2 px-3 btn-secondary d-flex justify-content-between align-items-center border-outline-light-bottom fs-8"
                      :class="
                        currentDistrict && currentDistrict._id == district._id
                          ? 'text-primary'
                          : ''
                      "
                      @click="currentDistrict = district"
                    >
                      {{ district.name }}
                      <font-awesome-icon
                        :icon="['fas', 'check']"
                        class="text-primary ml-3 small"
                        v-if="
                          currentDistrict && currentDistrict._id == district._id
                        "
                      />
                    </button>
                  </div>
                </div>
                <div class="dropdown ml-2">
                  <button
                    id="dropdownMenuButton"
                    type="button"
                    class="btn btn-sm"
                    :class="!dateFilter ? 'btn-light' : 'btn-primary'"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    data-placement="top"
                    title="Filter by Date"
                    @mouseover="helper.showTooltip"
                    @mouseleave="helper.hideTooltip"
                  >
                    <font-awesome-icon :icon="['far', 'calendar-alt']" />
                    <font-awesome-icon
                      :icon="['fas', 'check-circle']"
                      class="text-success bg-white rounded-circle"
                      style="
                        font-size: 0.85em;
                        position: absolute;
                        top: 0.25em;
                        right: 0.25em;
                      "
                      v-if="dateFilter"
                    />
                  </button>
                  <div
                    id="dropdown-menu"
                    class="dropdown-menu px-2 bg-white"
                    @click.stop
                  >
                    <div
                      class="dropdown-item-text d-flex justify-content-between align-items-center px-0 pb-2"
                    >
                      <p
                        class="badge badge-primary mb-0 font-weight-normal p-2"
                      >
                        Filter by date
                      </p>
                      <button
                        class="btn btn-sm btn-link p-0"
                        @click="dateFilter = null"
                      >
                        Clear
                      </button>
                    </div>
                    <v-date-picker
                      class="inline-calendar"
                      v-model="dateFilter"
                      :model-config="{
                        type: 'string',
                        mask: 'YYYY-MM-DD',
                      }"
                      mode="date"
                      trim-weeks
                      is-range
                    />
                  </div>
                </div>
              </div>
              <div class="dropdown-group">
                <div class="dropdown">
                  <button
                    class="btn btn-sm btn-light position-relative"
                    type="button"
                    id="layerMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    data-placement="top"
                    title="Filter by Layer"
                    @mouseover="helper.showTooltip"
                    @mouseleave="helper.hideTooltip"
                    @click="
                      dropdownActive == 'layers'
                        ? (dropdownActive = '')
                        : (dropdownActive = 'layers')
                    "
                    @blur="dropdownActive = ''"
                  >
                    <span class="mr-1">Layers</span>
                    <font-awesome-icon
                      v-if="dropdownActive == 'layers'"
                      class="angle-icon ml-1"
                      :icon="['fas', 'angle-up']"
                    />
                    <font-awesome-icon
                      v-else
                      class="angle-icon ml-1"
                      :icon="['fas', 'angle-down']"
                    />
                  </button>
                  <div
                    aria-labelledby="layerMenuButton"
                    class="dropdown-layer-menu dropdown-menu"
                  >
                    <div
                      class="dropdown-item-text fs-8"
                      :key="`layer-${layer.id}`"
                      v-for="layer in layers"
                      @click.stop
                    >
                      <div class="custom-control custom-checkbox py-2">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          :id="layer.id"
                          v-model="layer.show"
                          @change="toggleLayerVisibility(layer)"
                        />
                        <label
                          class="custom-control-label text-nowrap fs-8"
                          :for="layer.id"
                        >
                          {{ layer.name }}
                        </label>
                      </div>
                    </div>
                    <div
                      class="dropdown-item-text text-muted"
                      @click.stop
                      v-if="layers.length < 1"
                    >
                      No layer found
                    </div>
                    <div
                      class="dropdown-header font-weight-medium text-muted border-outline-light-bottom fs-8 py-2 px-3"
                      @click.stop
                    >
                      Maintenance Coverage
                    </div>
                    <template
                      v-for="(group, idx) in Object.keys(showMaintenanceGroup)"
                    >
                      <div
                        :key="group"
                        class="dropdown-item-text font-weight-medium small bg-light"
                        @click.stop
                      >
                        <div class="custom-control custom-checkbox py-2">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            :id="group"
                            v-model="showMaintenanceGroup[group]"
                            @change="
                              toggleGroupVisibility(group, 'Maintenance')
                            "
                          />
                          <label
                            class="custom-control-label text-nowrap fs-8"
                            :for="group"
                          >
                            {{ helper.snakeToTitleCase(group) }}
                          </label>
                        </div>
                      </div>
                      <div
                        class="dropdown-item-text"
                        :key="`${group}-route-${route._id}`"
                        v-for="route in maintenanceLayers.filter(
                          (l) => l.district && l.type == group
                        )"
                        @click.stop
                      >
                        <div class="custom-control custom-checkbox px-5 py-2">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            :id="route._id"
                            v-model="route.show"
                            @change="toggleLayerVisibility(route)"
                          />
                          <label
                            class="custom-control-label text-nowrap fs-8"
                            :for="route._id"
                          >
                            {{ route.district.name }}
                          </label>
                        </div>
                      </div>
                      <div
                        :key="`${group}-divider`"
                        v-if="
                          idx < Object.keys(showMaintenanceGroup).length - 1
                        "
                      ></div>
                    </template>
                    <div
                      class="dropdown-item-text text-muted text-center font-italic"
                      @click.stop
                      v-if="Object.keys(showMaintenanceGroup).length < 1"
                    >
                      No layer found
                    </div>
                  </div>
                </div>
                <div class="dropdown ml-2">
                  <button
                    class="btn btn-sm btn-light position-relative"
                    type="button"
                    id="workLayerMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    data-placement="top"
                    title="Filter by Work Layer"
                    @mouseover="helper.showTooltip"
                    @mouseleave="helper.hideTooltip"
                    aria-expanded="false"
                    @click="
                      dropdownActive == 'workLayers'
                        ? (dropdownActive = '')
                        : (dropdownActive = 'workLayers')
                    "
                    @blur="dropdownActive = ''"
                  >
                    <span class="mr-1">Work Layers</span>
                    <font-awesome-icon
                      v-if="dropdownActive == 'workLayers'"
                      class="angle-icon ml-1"
                      :icon="['fas', 'angle-up']"
                    />
                    <font-awesome-icon
                      v-else
                      class="angle-icon ml-1"
                      :icon="['fas', 'angle-down']"
                    />
                  </button>
                  <div
                    aria-labelledby="workLayerMenuButton"
                    class="dropdown-layer-menu dropdown-menu"
                  >
                    <template
                      v-for="(group, idx) in Object.keys(showWorkGroup)"
                    >
                      <div
                        :key="group"
                        class="dropdown-item-text font-weight-medium small text-muted fs-8"
                        @click.stop
                      >
                        {{ helper.snakeToTitleCase(group) }}
                      </div>
                      <div
                        class="dropdown-item-text"
                        :key="`${group}-route-${route._id}`"
                        v-for="route in workLayers.filter(
                          (l) => l.district.name == group
                        )"
                        @click.stop
                      >
                        <div class="custom-control custom-checkbox px-5 py-2">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            :id="route._id"
                            v-model="route.show"
                            @change="toggleLayerVisibility(route)"
                          />
                          <label
                            class="custom-control-label text-nowrap fs-8"
                            :for="route._id"
                          >
                            {{ helper.changeLabelWorkLayer(route.type) }}
                          </label>
                        </div>
                      </div>
                      <div
                        :key="`${group}-divider`"
                        v-if="idx < Object.keys(workLayers).length - 1"
                      ></div>
                    </template>
                    <div
                      class="dropdown-item-text text-muted text-center font-italic"
                      @click.stop
                      v-if="Object.keys(showWorkGroup).length < 1"
                    >
                      No layer found
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="toggle-button-map border rounded">
              <button
                type="button"
                class="btn btn-sm btn-light"
                @click="toggleMapStyle(!selectedMapStyle)"
                data-toggle="tooltip"
                data-placement="top"
                :title="
                  !selectedMapStyle
                    ? 'Switch to Satellite map style'
                    : 'Switch to Street map style'
                "
                @mouseover="helper.showTooltip"
                @mouseleave="helper.hideTooltip"
              >
                <font-awesome-icon
                  class="small mr-1"
                  :icon="
                    !selectedMapStyle ? ['fas', 'satellite'] : ['fas', 'road']
                  "
                />
                {{ !selectedMapStyle ? "Satellite" : "Street" }}
              </button>
            </div>

            <div>
              <button
                class="btn map-card-tip py-3 pl-3 pr-2 cursor-pointer rounded-left shadow"
                type="button"
                :style="!expandSummary ? 'right: 0rem' : `right: ${rightTip}`"
                @click="handleToggleSummary"
                data-toggle="tooltip"
                data-placement="left"
                title="Mini Dashboard"
                @mouseover="helper.showTooltip"
                @mouseleave="helper.hideTooltip"
              >
                <font-awesome-icon
                  class="cursor-pointer angle-icon fa-lg"
                  v-if="expandSummary"
                  :icon="['fas', 'angle-right']"
                />
                <font-awesome-icon
                  class="cursor-pointer angle-icon fa-lg"
                  v-if="!expandSummary"
                  :icon="['fas', 'angle-left']"
                />
              </button>
              <div
                class="map-card-dashboard fa-lg bg-white"
                :style="expandSummary ? 'right: 0px' : 'right: -195px'"
              >
                <div class="map-card-content shadow-sm">
                  <div>
                    <div class="dropdown-group">
                      <div class="dropdown mt-2 mx-1">
                        <button
                          type="button"
                          data-placement="top"
                          title="Filter by Work Layer"
                          @mouseover="helper.showTooltip"
                          @mouseleave="helper.hideTooltip"
                          class="btn btn-sm btn-light border-left-0 d-flex justify-content-between align-items-center rounded w-100"
                          @click="
                            visibleDropdownReportType =
                              !visibleDropdownReportType
                          "
                        >
                          <div>
                            {{ helper.changeLabelWorkLayer(reportTypeCase) }}
                          </div>
                          <div>
                            <font-awesome-icon
                              v-if="visibleDropdownReportType"
                              class="cursor-pointer ml-1 angle-icon"
                              :icon="['fas', 'angle-up']"
                            />
                            <font-awesome-icon
                              v-else
                              class="cursor-pointer ml-1 angle-icon"
                              :icon="['fas', 'angle-down']"
                            />
                          </div>
                        </button>
                        <div
                          class="dropdown-menu p-0"
                          style="max-height: 200px; overflow-y: auto"
                          :style="
                            visibleDropdownReportType
                              ? 'display: block'
                              : 'display: none'
                          "
                        >
                          <button
                            v-for="reportType in reportTypeArr"
                            :key="reportType.value"
                            class="dropdown-item btn-secondary d-flex justify-content-between align-items-center fs-8 px-3 py-2 border-outline-light-bottom"
                            :class="
                              reportTypeCase == reportType.value
                                ? 'text-primary'
                                : 'text-dark'
                            "
                            @click="handleChangeReportType(reportType)"
                          >
                            <span
                              >{{
                                helper.changeLabelWorkLayer(reportType.value)
                              }}
                              <font-awesome-icon
                                :icon="['fas', 'check']"
                                class="text-primary ml-3 small"
                                v-if="reportTypeCase == reportType.value"
                            /></span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="dropdown-divider my-3 border-top mx-1 border-outline-light-bottom"
                  ></div>
                  <div class="mx-3">
                    <p class="text-center small mb-2 font-weight-bold fh-1">
                      Summary Case
                      {{
                        reportTypeCase != "All"
                          ? `/ ${helper.changeLabelWorkLayer(reportTypeCase)}`
                          : ""
                      }}
                    </p>

                    <div class="row">
                      <div
                        v-for="(report, idx) in summaryReport"
                        :key="idx"
                        :class="idx == 0 ? 'col-12 p-0' : 'col-6 p-0'"
                      >
                        <div
                          class="text-center p-1 rounded m-1 border border-light"
                          style="cursor: pointer"
                          :class="report.color"
                          @click="
                            caseByStatus =
                              idx == 0 ? 'All' : report.tooltip || report.label
                          "
                          data-placement="left"
                          data-toggle="tooltip"
                          :title="`Filter by ${report.tooltip || report.label}`"
                          @mouseover="helper.showTooltip"
                          @mouseleave="helper.hideTooltip"
                        >
                          <h4 v-if="idx == 0" class="font-weight-bold mb-0">
                            {{ report.value }}
                          </h4>
                          <h6 v-else class="font-weight-bold mb-0">
                            {{ report.value }}
                          </h6>
                          <p
                            style="font-size: 0.7rem"
                            class="small text-center mb-0 text-break"
                          >
                            {{
                              report.label === "Tampalan"
                                ? "Patching"
                                : report.label
                            }}
                          </p>
                          <font-awesome-icon
                            :icon="['fas', 'check-circle']"
                            class="text-success bg-white rounded-circle"
                            style="
                              font-size: 0.8em;
                              position: absolute;
                              top: 0.05em;
                              right: 0.25em;
                            "
                            v-if="
                              caseByStatus ==
                              (report.label == 'Total Case'
                                ? 'All'
                                : report.label == 'Tampalan'
                                ? 'Tampalan PBT'
                                : `${report.label} Case`)
                            "
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="map" class=""></div>
            <div
              class="btn map-legend cursor-pointer border border-bottom-0"
              data-toggle="tooltip"
              data-placement="top"
              title="Legend"
              @mouseover="helper.showTooltip"
              @mouseleave="helper.hideTooltip"
              :class="{ expand: expandLegend }"
              @click="expandLegend = !expandLegend"
            >
              <p
                class="px-3 font-weight-medium mb-0 d-flex justify-content-between align-items-center"
              >
                Legend
                <font-awesome-icon
                  class="angle-icon"
                  :icon="['fas', 'angle-down']"
                />
              </p>
              <div
                class="legend-body d-flex flex-column justify-content-start align-items-start"
              >
                <div class="legend-item">
                  <div class="defect-marker mr-2 bg-danger"></div>
                  Open Case
                </div>
                <div class="legend-item">
                  <div class="defect-marker mr-2 bg-success"></div>
                  Closed Case
                </div>
                <!-- <div class="legend-item">
                  <div class="defect-marker mr-2 bg-warning"></div>
                  NOE Case
                </div> -->
                <div class="legend-item">
                  <div class="defect-marker mr-2 bg-info"></div>
                  Patching
                </div>
                <div class="legend-item">
                  <div
                    class="defect-marker mr-2 bg-danger border-success"
                    style="border: 3px solid green"
                  ></div>
                  Verified Defect
                </div>

                <!-- <div class="legend-item">
                  <img
                    src="@/assets/icons/marker.png"
                    alt="marker icon"
                    class="mr-2"
                    style="width: 1rem; height: 1rem"
                  />
                  Premix Plant
                </div>
                <div class="legend-item">
                  <img
                    src="@/assets/icons/water.png"
                    alt="marker icon"
                    class="mr-2"
                    style="width: 0.9rem; height: 1rem"
                  />
                  Flood Area
                </div> -->
                <div class="legend-item">
                  <div
                    class="route-line mr-2 shadow-sm"
                    style="background-color: #ff0000"
                  ></div>
                  Protocol Road
                </div>
                <div class="legend-item">
                  <div
                    class="route-line mr-2 shadow-sm"
                    style="background-color: #ffff00"
                  ></div>
                  Secondary Road
                </div>
                <div class="legend-item">
                  <div
                    class="route-line mr-2 shadow-sm"
                    style="background-color: #00aa00"
                  ></div>
                  Main Road
                </div>
                <div class="legend-item">
                  <div
                    class="route-line mr-2 shadow-sm"
                    style="background-color: #00ffff"
                  ></div>
                  Minor Road
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <media-preview
      :downloadImage="true"
      v-if="currentImage"
      :url="currentImage"
      @close="currentImage = null"
    />
    <spinner v-if="isProcessing" />
  </div>
</template>

<script>
import API from "@/api";
import "mapbox-gl";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import $ from "jquery";
import moment from "moment";
import Spinner from "@/components/Spinner";
import Pin from "@/components/Pin";
import MediaPreview from "@/components/MediaPreview";
import Quarries from "@/quarries";
import BanjirGombak from "@/banjirGombak";
import BanjirHuluLangat from "@/banjirHuluLangat";
import BanjirHuluSelangor from "@/banjirHuluSelangor";
import BanjirKlang from "@/banjirKlang";
import BanjirKualaLangat from "@/banjirKualaLangat";
import BanjirPj from "@/banjirPj";
import Helper from "@/helper";
import banjir from "@/banjir.json";

const lastWeek = moment()
  .subtract(1, "week")
  .startOf("day")
  .format("YYYY-MM-DD");
const today = moment().endOf("day").format("YYYY-MM-DD");

export default {
  name: "defects",
  components: {
    Pin,
    spinner: Spinner,
    MediaPreview,
  },
  data() {
    return {
      dropdownActive: "",
      visibleDropdownReportType: false,
      helper: Helper,
      currentImage: null,
      selectedCaseItem: null,
      isProcessing: false,
      map: null,
      cases: [],
      districts: [],
      currentDistrict: null,
      dateFilter: {
        start: lastWeek,
        end: today,
      },
      userDistricts: [],
      userRole: null,
      newBanjir: [
        ...BanjirPj,
        ...BanjirGombak,
        ...BanjirHuluLangat,
        ...BanjirHuluSelangor,
        ...BanjirKlang,
        ...BanjirKualaLangat,
      ],
      quarries: Quarries,
      maintenanceLayers: [],
      showMaintenanceGroup: {},
      workLayers: [],
      kmlDataSource: [],
      showWorkGroup: {},
      expandSummary: false,
      expandLegend: false,
      timeoutMouse: 0,
      timeoutSearch: 0,
      reportTypeArr: [
        {
          label: "All",
          value: "All",
        },
        // {
        //   label: "KKE",
        //   value: "KKE",
        // },
        {
          label: "Maintenance",
          value: "R01",
        },
        {
          label: "Inspection",
          value: "R09",
        },
        // {
        //   label: "R02",
        //   value: "R02",
        // },
        // {
        //   label: "R03",
        //   value: "R03",
        // },
        // {
        //   label: "R04",
        //   value: "R04",
        // },
        // {
        //   label: "R05",
        //   value: "R05",
        // },
        // {
        //   label: "R06",
        //   value: "R06",
        // },
        // {
        //   label: "R07",
        //   value: "R07",
        // },
        // {
        //   label: "R08",
        //   value: "R08",
        // },
        // {
        //   label: "R11",
        //   value: "R11",
        // },
      ],
      layers: [
        {
          id: "defects",
          layer: "circle",
          name: "Defects",
          show: true,
        },
        // {
        //   id: "quarry",
        //   layer: "quarryLayer",
        //   name: "Premix Plant",
        //   show: false,
        // },
        // {
        //   id: "banjir",
        //   layer: "banjirLayer",
        //   name: "Flood Area",
        //   show: false,
        // },
      ],
      caseSource: [],
      reportTypeCase: "All",
      caseByStatus: "All",
      countCasesLoading: true,
      selectedMapStyle: false,
      rightTip: "195px",
      timeout: 0,
      countTime: 0,
      roadsData: {},
    };
  },
  watch: {
    dateFilter: {
      handler() {
        $(".dropdown-toggle").dropdown("hide");
        this.removeMapResources();
        this.getCases();
      },
      immediate: false,
    },
    currentDistrict: {
      handler() {
        this.removeMapResources();
        this.getCases();
        this.loadKML();
      },
      immediate: false,
    },
    caseByStatus: {
      handler() {
        if (this.map) {
          const layers = this.map
            .getStyle()
            .layers.filter((layer) => layer.id.includes(`circle-`));

          if (layers && layers.length > 0) {
            let status = "";
            if (this.caseByStatus == "Closed Case") {
              status = "closed";
            } else if (this.caseByStatus == "Open Case") {
              status = "open";
            } else if (this.caseByStatus == "NOE") {
              status = "noe";
            } else if (this.caseByStatus == "Tampalan PBT") {
              status = "tampalan_pbt";
            }

            if (this.caseByStatus != "All") {
              layers.forEach((element) => {
                this.map.setLayoutProperty(
                  element.id,
                  "visibility",
                  element.id.includes(
                    `circle-${status}${
                      this.reportTypeCase != "All"
                        ? `-${this.reportTypeCase}`
                        : ``
                    }`
                  )
                    ? "visible"
                    : "none"
                );
              });
            } else {
              layers.forEach((element) => {
                this.map.setLayoutProperty(
                  element.id,
                  "visibility",
                  element.id.includes(
                    `${
                      this.reportTypeCase != "All"
                        ? `${this.reportTypeCase}`
                        : ``
                    }`
                  )
                    ? "visible"
                    : "none"
                );
              });
            }
          }
        }
      },
      immediate: true,
    },
    reportTypeCase: {
      handler() {
        if (this.map) {
          const layers = this.map
            .getStyle()
            .layers.filter((layer) => layer.id.includes(`circle-`));

          if (layers && layers.length > 0) {
            let status = "";
            if (this.caseByStatus == "Closed Case") {
              status = "closed";
            } else if (this.caseByStatus == "Open Case") {
              status = "open";
            } else if (this.caseByStatus == "NOE") {
              status = "noe";
            } else if (this.caseByStatus == "Tampalan PBT") {
              status = "tampalan_pbt";
            }

            if (this.reportTypeCase != "All") {
              layers.forEach((element) => {
                this.map.setLayoutProperty(
                  element.id,
                  "visibility",
                  element.id.includes(
                    `${status ? `circle-${status}-` : ``}${this.reportTypeCase}`
                  )
                    ? "visible"
                    : "none"
                );
              });
            } else {
              layers.forEach((element) => {
                this.map.setLayoutProperty(
                  element.id,
                  "visibility",
                  element.id.includes(`${status ? `circle-${status}-` : ``}`)
                    ? "visible"
                    : "none"
                );
              });
            }
          }
        }
      },
      immediate: true,
    },
  },
  computed: {
    summaryReport() {
      const newData = [...this.caseSource];
      const filterBygroup =
        this.reportTypeCase != "All"
          ? newData.filter((x) => x.reportType == this.reportTypeCase)
          : newData;
      const openCase = filterBygroup.filter(
        (x) => x.status != "solved" && x.category != "Tampalan_PBT"
      );
      const closeCase = filterBygroup.filter(
        (x) => x.status == "solved" && x.category != "Tampalan_PBT"
      );
      const noeCase = filterBygroup.filter((x) => x.isNoe);
      const tampalanCase = filterBygroup.filter(
        (x) => x.category == "Tampalan_PBT"
      );

      return [
        {
          label: "Total Case",
          color: "bg-light",
          value: openCase.length + closeCase.length,
        },
        {
          label: "Open",
          color: "bg-danger",
          value: openCase.length,
          tooltip: "Open Case",
        },
        {
          label: "Closed",
          color: "bg-success",
          value: closeCase.length,
          tooltip: "Closed Case",
        },
        // {
        //   label: "NOE",
        //   color: "bg-warning-2",
        //   value: noeCase.length,
        //   tooltip: "NOE",
        // },
        {
          label: "Tampalan",
          color: "bg-info border border-light",
          value: tampalanCase.length,
          tooltip: "Tampalan PBT",
        },
      ];
    },
  },
  methods: {
    handleChangeReportType(reportType) {
      this.visibleDropdownReportType = !this.visibleDropdownReportType;
      this.reportTypeCase = reportType.value;
    },
    handleToggleSummary() {
      this.expandSummary = !this.expandSummary;

      const searchingBar = document.getElementsByClassName(
        "mapboxgl-ctrl-top-right"
      );

      if (searchingBar.length > 0) {
        searchingBar[0].style.display = !this.expandSummary ? "none" : "block";
        this.rightTip = `${searchingBar[0].scrollWidth >= 127 ? 195 : 195}px`;
      }
    },
    toggleMapStyle(style) {
      this.selectedMapStyle = style;
      const satelliteStyle = "mapbox://styles/mapbox/satellite-v9";
      const defaultStyle = "mapbox://styles/mapbox/light-v11";
      this.map.setStyle(style ? satelliteStyle : defaultStyle);
      this.reDrawMarker();
    },
    toggleGroupVisibility(group, type) {
      this[`${type.toLowerCase()}Layers`]
        .filter((l) => l.type == group)
        .forEach((route) => {
          route.show =
            this[`show${type}Group`][group].show ||
            this[`show${type}Group`][group];

          this.toggleLayerVisibility(route);
        });
    },
    toggleLayerVisibility(layer) {
      if (layer.layer == "circle") {
        const layers = this.map
          .getStyle()
          .layers.filter((layer) => layer.id.includes("circle-"));

        layers.forEach((element) => {
          this.map.setLayoutProperty(
            element.id,
            "visibility",
            layer.show ? "visible" : "none"
          );
        });
      } else {
        this.map.setLayoutProperty(
          layer.layer,
          "visibility",
          layer.show ? "visible" : "none"
        );
      }
    },
    onPinSelected(caseItem) {
      this.selectedCaseItem = caseItem;
    },
    forwardGeocoder(query) {
      const matches = query?.match(
        /^[ ]*(?:Lat: )?(-?\d+\.?\d*)[, ]+(?:Lng: )?(-?\d+\.?\d*)[ ]*$/i
      );

      let customData = {};

      // if (!matches) {
      //   // customData = {
      //   //   features: this.roadsData.filter((data) =>
      //   //     data.properties.title?.toLowerCase().includes(query?.toLowerCase())
      //   //   ),
      //   //   type: "FeatureCollection",
      //   // };
      // } else {
      function coordinateFeature(lng, lat) {
        return {
          center: [lng, lat],
          geometry: {
            type: "Point",
            coordinates: [lng, lat],
          },
          place_name: "Lat: " + lat + " Lng: " + lng,
          properties: {
            title: "Lat: " + lat + " Lng: " + lng,
          },
          type: "Feature",
        };
      }

      const coord1 = Number(matches[1]);
      const coord2 = Number(matches[2]);
      const geocodes = [];

      if (coord1 < -90 || coord1 > 90) {
        geocodes.push(coordinateFeature(coord1, coord2));
      }

      if (coord2 < -90 || coord2 > 90) {
        geocodes.push(coordinateFeature(coord2, coord1));
      }

      if (geocodes.length === 0) {
        geocodes.push(coordinateFeature(coord1, coord2));
        geocodes.push(coordinateFeature(coord2, coord1));
      }

      customData["features"] = geocodes;
      // }

      const matchingFeatures = [];

      if (customData.features !== undefined && customData.features.length > 0) {
        for (const feature of customData.features) {
          if (feature.geometry.coordinates[0] !== undefined) {
            feature["place_name"] = `${feature.properties.title}`;
            feature["matching_place_name"] = `${feature.properties.title}`;
            feature["center"] = feature.geometry.coordinates;
            feature["place_type"] = ["place"];
            matchingFeatures.push(feature);
          }
        }
      }

      return matchingFeatures;
    },
    async getRoadsData() {
      return new Promise((resolve) => {
        const url = `roadsOnly?lat_null=false&lng_null=false&daerah_null=false&_limit=-1`;

        API.get(url)
          .then((response) => {
            this.roadsData = response.data
              .filter((item) => item.lat && item.lng)
              .map((item) => {
                return {
                  type: "Feature",
                  properties: {
                    title: `${item.name}, ${item.subdistrict}, ${item.district}`,
                  },
                  geometry: {
                    coordinates: [item.lng, item.lat],
                    type: "Point",
                  },
                };
              });

            resolve();
          })
          .catch((err) => {
            resolve();
            console.log("====================================");
            console.log(err);
            console.log("====================================");
          });
      });
    },
    async initMap() {
      return new Promise((resolve) => {
        mapboxgl.accessToken = process.env.VUE_APP_MAPBOX_KEY;
        this.map = new mapboxgl.Map({
          container: "map",
          style: "mapbox://styles/mapbox/light-v11",
          center: [138.8843188, 37.6689239],
          zoom: 9,
        });

        this.map.on("load", async () => {
          const geocoder = new MapboxGeocoder({
            accessToken: process.env.VUE_APP_MAPBOX_KEY,
            localGeocoder: this.forwardGeocoder,
            zoom: 12,
            limit: 10,
            placeholder: "Enter search e.g. Shah Alam",
            mapboxgl: mapboxgl,
            marker: {
              color: "orange",
            },
          });

          geocoder.setCountries("MY");

          this.map.addControl(geocoder);

          resolve();
        });
      });
    },
    addQuarryMarker() {
      return new Promise((resolve) => {
        this.map.loadImage(
          require("@/assets/icons/marker.png"),
          (err, image) => {
            if (err) {
              console.error(err);

              return;
            }

            this.map.addImage("quarry-marker", image);
          }
        );

        this.map.addSource("quarrySource", {
          type: "geojson",
          data: {
            type: "FeatureCollection",
            features: this.quarries.map((quarry) => {
              return {
                type: "Feature",
                geometry: {
                  type: "Point",
                  coordinates: [quarry.lng, quarry.lat],
                },
                properties: {
                  title: quarry.name,
                },
              };
            }),
          },
        });

        this.map.addLayer({
          id: "quarryLayer",
          type: "symbol",
          source: "quarrySource",
          layout: {
            "icon-image": "quarry-marker",
            "text-field": ["get", "title"],
            "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
            "text-size": 10,
            "text-offset": [0, 1.25],
            "text-anchor": "top",
            "icon-allow-overlap": true,
            "text-allow-overlap": true,
          },
          paint: {
            "text-color": "#ffffff",
            "text-halo-width": 1,
            "text-halo-color": "#000",
            "text-halo-blur": 1,
          },
        });

        resolve();
        this.map.setLayoutProperty("quarryLayer", "visibility", "none");
      });
    },
    viewCase(caseId) {
      this.$router.push({ name: "inbox", params: { id: caseId } });
    },
    loadKML() {
      return new Promise(async (resolve) => {
        let query = "layers?_limit=-1";

        if (this.currentDistrict) {
          query += `&district=${this.currentDistrict._id}`;
        } else if (this.userDistricts.length > 0) {
          query += `&district_in=${this.userDistricts
            .map((ud) => ud._id)
            .join("&district_in=")}`;
        }

        const response = await API.get(query);
        this.kmlDataSource = response.data;

        this.displayKML();
        resolve();
      });
    },
    removeMaintenanceResources() {
      const layers = this.map
        .getStyle()
        .layers.filter((layer) => layer.id.includes("route-"));

      const sources = Object.keys(this.map.getStyle().sources).filter(
        (source) => source.includes("route-")
      );

      if (layers && layers.length > 0) {
        layers.forEach((layer) => {
          this.map.removeLayer(layer.id);
        });
      }

      if (sources && sources.length > 0) {
        sources.forEach((source) => {
          this.map.removeSource(source);
        });
      }
    },
    removeMapResources() {
      this.map.off(
        "click",
        this.selectedCaseItem,
        this.handleOnClickMarkerCircle
      );
      const layers = this.map
        .getStyle()
        .layers.filter((layer) => layer.id.includes("circle-"));

      layers.forEach((item) => {
        const data = this.map
          .getStyle()
          .layers.filter((layer) => layer.id.includes(item.id));

        const sources = Object.keys(this.map.getStyle().sources).filter(
          (source) => source.includes(item.id)
        );

        if (data && data.length > 0) {
          layers.forEach((layer) => {
            this.map.removeLayer(layer.id);
          });
        }

        if (sources && sources.length > 0) {
          sources.forEach((source) => {
            this.map.removeSource(source);
          });
        }
      });
    },
    async getCases() {
      this.isProcessing = true;

      this.cases = [];

      let url =
        "cases/defects?timestamp_null=false&_sort=timestamp:DESC&_limit=-1&source_ne=socialMedia";

      if (this.userRole == "JKR District") {
        this.reportTypeCase = "Tender";
      } else {
        url += `&reportType_nin=Tender`;
      }
      // console.log(this.reportTypeCase);

      if (this.reportTypeCase != "All") {
        url += `&reportType=${this.reportTypeCase}`;
      } else {
        // url += "&reportType_nin=R09";
      }

      if (this.currentDistrict) {
        url += `&district=${this.currentDistrict._id}`;
      } else if (this.userDistricts.length > 0) {
        url += `&district_in=${this.userDistricts
          .map((ud) => ud._id)
          .join("&district_in=")}`;
      }

      if (this.dateFilter && this.dateFilter.start && this.dateFilter.end) {
        const _dateFilter = {
          start: moment(this.dateFilter.start).startOf("day").toISOString(),
          end: moment(this.dateFilter.end).endOf("day").toISOString(),
        };

        url += `&timestamp_gte=${_dateFilter.start}&timestamp_lte=${_dateFilter.end}`;
      }

      if (this.caseByStatus == "Open Case") {
        url += `&status_ne=solved`;
      } else if (this.caseByStatus == "Closed Case") {
        url += `&status=solved`;
      } else if (this.caseByStatus == "NOE") {
        url += `&isNoe=true`;
      } else if (this.caseByStatus == "Tampalan PBT") {
        url += "&category=Tampalan_PBT";
      }

      return API.get(url)
        .then(async (retVal) => {
          this.countCasesLoading = false;
          if (this.caseByStatus == "All") {
            this.caseSource = retVal.data.filter(
              (caseItem) => caseItem.lat != null && caseItem.lng != null
            );
          }

          this.cases = retVal.data.filter(
            (caseItem) => caseItem.lat != null && caseItem.lng != null
          );

          this.displayDefectMarkers();
          // this.displayVerifiedDefectMarkers();

          this.isProcessing = false;
        })
        .catch((err) => {
          console.error(err);

          this.isProcessing = false;
        });
    },
    viewImage(url) {
      this.currentImage = url;
    },
    async getDistricts() {
      this.isProcessing = true;

      let url = "districts?_sort=name";

      if (this.userDistricts.length > 0) {
        url = url
          .concat("&_id_in=")
          .concat(
            this.userDistricts.map((district) => district._id).join("&_id_in=")
          );
      }

      return API.get(url)
        .then((retVal) => {
          this.districts = retVal.data;

          this.isProcessing = false;
        })
        .catch((err) => {
          console.error(err);

          this.isProcessing = false;
        });
    },
    async generateNumber(id) {
      const response = await API.get(`cases/${id}`);
      return response.data.caseNumber && response.data.caseNumber;
    },
    displayKML() {
      this.removeMaintenanceResources();
      this.maintenanceLayers = [];
      this.showMaintenanceGroup = {};
      this.workLayers = [];
      this.showWorkGroup = {};

      if (this.kmlDataSource.length > 0) {
        this.kmlDataSource.forEach((layer, index) => {
          if (layer.type.includes("R0")) layer.show = false;
          else layer.show = true;

          layer.layer = `route-${layer.type}-${layer._id}`;

          if (layer.group == "Maintenance_Coverage") {
            this.maintenanceLayers.push(layer);

            this.$set(this.showMaintenanceGroup, layer.type, true);

            this.map.addSource(`route-${layer.type}-${layer._id}`, {
              type: "geojson",
              data: layer.file.url,
            });

            this.map.addLayer({
              id: `route-${layer.type}-${layer._id}`,
              type: "line",
              source: `route-${layer.type}-${layer._id}`,
              layout: {
                "line-join": "round",
                "line-cap": "round",
              },
              paint: {
                "line-color": ["get", "stroke"],
                "line-width": ["get", "stroke-width"],
                "line-opacity": ["get", "stroke-opacity"],
              },
            });
          } else if (layer.group == "Work_Layer") {
            this.workLayers.push(layer);

            const workGroup = {
              show: false,
              color: Helper.colors(index),
            };

            this.$set(this.showWorkGroup, layer.district.name, workGroup);

            this.map.addSource(`route-${layer.type}-${layer._id}`, {
              type: "geojson",
              data: layer.file.url,
            });

            this.map.addLayer({
              id: `route-${layer.type}-${layer._id}`,
              type: "line",
              source: `route-${layer.type}-${layer._id}`,
              type: "circle",
              paint: {
                "circle-radius": 5,
                "circle-color": workGroup.color,
                "circle-opacity": 0.75,
                "circle-stroke-width": 0,
              },
              layout: {
                visibility: "none",
              },
            });

            this.map.on("click", `route-${layer.type}-${layer._id}`, (e) => {
              let gjsonFeatures = "";

              Object.keys(e.features[0].properties).forEach((feature) => {
                gjsonFeatures += `<tr>
                    <td class=" border-light">${feature}</td>
                    <td class=" border-light">${e.features[0].properties[feature]}</td>
                  </tr>`;
              });

              let popupContainer = `<div class="mapbox-popup-container ">
                  <p class="popup-header  border-outline-light-bottom">
                    ${Helper.formatGeojsonName(layer.name)}
                  </p>
                  <div class="popup-content">
                    <table class="table table-striped table-sm mb-0">
                      ${gjsonFeatures}
                    </table>
                  </div>
                </div>`;

              new mapboxgl.Popup()
                .setLngLat(e.lngLat)
                .setHTML(popupContainer)
                .addTo(this.map);
            });

            this.map.on(
              "mouseenter",
              `route-${layer.type}-${layer._id}`,
              () => {
                this.map.getCanvas().style.cursor = "pointer";
              }
            );

            this.map.on(
              "mouseleave",
              `route-${layer.type}-${layer._id}`,
              () => {
                this.map.getCanvas().style.cursor = "";
              }
            );
          }
        });
      }
    },
    displayVerifiedDefectMarkers() {
      const features = this.cases
        .filter((c) => c.verifications && c.verifications.length > 0)
        .map((c) => {
          return {
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: [c.lng, c.lat],
            },
            properties: {
              id: c.id,
              imageUrl: c.media && c.media.length ? c.media[0].url : "",
              caption: c.caption,
              roadName: null,
              verifications: c.verifications
                .filter((v) => v.media.length > 0)
                .map((v) => v.media.map((m) => m.url))
                .flat(),
              coordinate: c.lat && c.lng ? [c.lat, c.lng] : [],
            },
          };
        });

      this.map.addSource("circles-verified", {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features,
        },
      });

      this.map.addLayer({
        id: "circles-verified",
        source: "circles-verified",
        type: "circle",
        paint: {
          "circle-radius": 3,
          "circle-color": "#FA4147",
          "circle-opacity": 0.5,
          "circle-stroke-width": 2,
          "circle-stroke-color": "#04D15A",
        },
      });

      this.map.on("mouseenter", "circles-verified", () => {
        this.map.getCanvas().style.cursor = "pointer";
      });

      this.map.on("mouseleave", "circles-verified", () => {
        this.map.getCanvas().style.cursor = "";
      });

      this.map.on("click", "circles-verified", async (e) => {
        const props = e.features[0].properties;

        props.coordinate = JSON.parse(props.coordinate);

        const propVerifications = JSON.parse(props.verifications);

        let verificationImages = "";
        const caseNumber = await this.generateNumber(props.id);
        if (propVerifications.length > 1) {
          let imageCols = "";

          propVerifications.forEach((e) => {
            imageCols += `
              <div class="col-6 px-1 pb-1">
                <div class="embed-responsive embed-responsive-4by3 bg-light border">
                  <img class="defect-thumbnail embed-responsive-item clickable mb-0" src="${e}" />
                </div>
              </div>
            `;
          });

          verificationImages = `
            <div class="row mx-n1" style="height: calc(100% - 14px - 0.5rem)">
              ${imageCols}
            </div>
          `;
        } else if (propVerifications.length == 1) {
          verificationImages = `
            <div class="w-100 pb-1" style="height: calc(100% - 14px - 0.5rem)">
              <img class="defect-thumbnail clickable mb-0" src="${propVerifications[0]}" />
            </div>
          `;
        }

        let coordinateLink =
          props.coordinate.length == 2
            ? `<div class="mb-cap">
              <a class="btn btn-link p-0" href="https://maps.google.com/?q=${
                props.coordinate[0]
              },${props.coordinate[1]}" target="_blank">
                ${Helper.formatCoordinate(props.coordinate)}
              </a>
            </div>`
            : "";

        const html = `
					<div class="mb-popup">
            <div class="row mx-0">
              <div class="col pl-0 pr-1">
                <p class="mb-1 badge badge-danger">Defect Image</p>
                <div class="w-100 pb-1" style="height: calc(100% - 14px - 0.5rem)">
                  <img class="defect-thumbnail clickable mb-0" src="${props.imageUrl}" />
                </div>
              </div>
              <div class="col pl-1 pr-0">
                <p class="mb-1 badge badge-success">Verification Image</p>
                ${verificationImages}
              </div>
            </div>
						<div class="mb-cap pt-3">
              <a class="text-dark" href="https://infrasel.co/#/cases/${caseNumber}" target="_blank">
                ${props.caption}
              </a>
            </div>
            <div class="text-dark">${coordinateLink}</div>
					</div>
				`;

        new mapboxgl.Popup({
          maxWidth: "500px",
          closeButton: false,
          closeOnClick: true,
        })
          .setLngLat(e.lngLat)
          .setHTML(html)
          .on("open", () => {
            $(".defect-thumbnail").on("click", (e) => {
              this.viewImage(e.target.src);
            });
          })
          .on("close", () => {
            $(".defect-thumbnail").off("click");
          })
          .addTo(this.map);
      });
    },
    convertNameStatus(status) {
      if (status == "tampalan_pbt") {
        return "tampalan_pbt";
      } else if (status != "solved") {
        return "open";
      } else if (status == "solved") {
        return "closed";
      } else if (status == "noe") {
        return "noe";
      }
    },
    displayDefectMarkers() {
      // example source name = circle-status-R01-case_id
      const newData = this.cases
        // .filter(
        //   (c) =>
        //     (c.road || (c.category == "Tampalan_PBT" && !c.road)) &&
        //     (!c.verifications || c.verifications.length == 0)
        // )
        .map((item) => {
          return {
            name: `circle-${this.convertNameStatus(
              item.isNotify
                ? "notify"
                : item.isNoe
                ? "noe"
                : item.category == "Tampalan_PBT"
                ? "tampalan_pbt"
                : item.status
            )}-${item.reportType}-${item.id}`,
            color:
              item.category == "Tampalan_PBT"
                ? "#028EE6"
                : item.isNoe
                ? "#FD8326"
                : item.status != "solved"
                ? "#FA4147"
                : "#28a745",
            data: item,
          };
        });
      this.createMarker(newData);
    },
    createMarker(source) {
      // console.log(source);

      source.forEach((c) => {
        let obj = {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [c.data.lng, c.data.lat],
          },
          properties: {
            id: c.data.id,
            imageUrl:
              c.data.media && c.data.media.length ? c.data.media[0].url : "",
            caption: c.data.caption,
            roadName: null,
            coordinate:
              c.data.lat && c.data.lng ? [c.data.lat, c.data.lng] : [],
          },
        };

        this.map.addSource(c.name, {
          type: "geojson",
          data: {
            type: "FeatureCollection",
            features: [obj],
          },
        });

        this.map.addLayer({
          id: c.name,
          source: c.name,
          type: "circle",
          paint: {
            "circle-radius": c.data.category == "Tampalan_PBT" ? 5 : 6,
            "circle-color": c.color,
            "circle-opacity": 1,
            "circle-stroke-color": "#ffffff",
            "circle-stroke-width": c.data.category == "Tampalan_PBT" ? 1 : 0,
          },
          layout: {
            visibility: "visible",
          },
        });

        this.map.on("mouseenter", c.name, () => {
          this.map.getCanvas().style.cursor = "pointer";
        });

        this.map.on("mouseleave", c.name, () => {
          this.map.getCanvas().style.cursor = "";
        });

        this.map.on("click", c.name, this.handleOnClickMarkerCircle);
      });
    },
    displaySelectedDefectMarksers() {
      let arrays = [
        "circles-open-case",
        "circles-closed-case",
        "circles-noe-case",
      ];
      arrays.forEach((element) => {
        if (this.caseByStatus == "Open Case") {
          this.map.setLayoutProperty(
            element,
            "visibility",
            element == "circles-open-case" ? "visible" : "none"
          );
        } else if (this.caseByStatus == "Closed Case") {
          this.map.setLayoutProperty(
            element,
            "visibility",
            element == "circles-closed-case" ? "visible" : "none"
          );
        }
      });
    },
    async handleOnClickMarkerCircle(e) {
      const props = e.features[0].properties;

      props.coordinate = JSON.parse(props.coordinate);

      this.onPinSelected(e.features[0].layer.id);
      const caseNumber = await this.generateNumber(props.id);

      let url =
        this.userRole != "JKR District"
          ? `${window.location.origin}/#/cases/${caseNumber}`
          : `${window.location.origin}/#/tenders`;

      let coordinateLink =
        props.coordinate.length == 2
          ? `<div class="mb-cap">
              <a class="btn btn-link p-0" href="https://maps.google.com/?q=${
                props.coordinate[0]
              },${props.coordinate[1]}" target="_blank">
                ${Helper.formatCoordinate(props.coordinate)}
              </a>
            </div>`
          : "";

      const html = `
					<div class="mb-popup">
						<img class="defect-thumbnail clickable" src="${props.imageUrl}" />
						<div class="mb-cap"> 
              <a class="btn btn-link p-0 " href="${url}" target="_blank">
                ${props.caption}
              </a>
            </div>
            ${coordinateLink}
					</div>
				`;

      new mapboxgl.Popup({
        maxWidth: "500px",
        closeButton: false,
        closeOnClick: true,
      })
        .setLngLat(e.lngLat)
        .setHTML(html)
        .on("open", () => {
          $(".defect-thumbnail").on("click", (e) => {
            this.viewImage(e.target.src);
          });
        })
        .on("close", () => {
          $(".defect-thumbnail").off("click");
        })
        .addTo(this.map);
    },
    loadKMLBanjir() {
      return new Promise((resolve) => {
        this.map.loadImage(
          require("@/assets/icons/water.png"),
          (err, image) => {
            if (err) {
              console.error(err);

              return;
            }

            this.map.addImage("banjir-marker", image);
          }
        );

        const newBanjir = this.newBanjir.map((banjir) => {
          return {
            id: "1.2.1",
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: [banjir.lng, banjir.lat],
            },
            properties: {
              name: banjir.name,
            },
          };
        });

        let newData = {
          ...banjir[0],
          features: [...banjir[0].features, ...newBanjir],
        };

        this.map.addSource("banjirSource", {
          type: "geojson",
          data: newData,
        });

        this.map.addLayer({
          id: "banjirLayer",
          type: "symbol",
          source: "banjirSource",
          layout: {
            "icon-image": "banjir-marker",
            "text-field": ["get", "name"],
            "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
            "text-size": 10,
            "text-offset": [0, 1.25],
            "text-anchor": "top",
            "icon-allow-overlap": true,
            "text-allow-overlap": true,
          },
          paint: {
            "text-color": "#ffffff",
            "text-halo-width": 1,
            "text-halo-color": "#000",
            "text-halo-blur": 1,
          },
        });

        resolve();
        this.map.setLayoutProperty("banjirLayer", "visibility", "none");
      });
    },
    reDrawMarker() {
      this.isProcessing = true;
      this.removeMapResources();
      this.removeMaintenanceResources();

      setTimeout(() => {
        this.displayDefectMarkers();
        this.displayVerifiedDefectMarkers();
        this.displayKML();
        this.addQuarryMarker();
        this.loadKMLBanjir();
        this.isProcessing = false;
      }, 1000);
    },
  },

  async mounted() {
    this.isProcessing = true;

    let _user = localStorage.getItem("user");

    if (_user) {
      _user = JSON.parse(_user);

      if (_user.districts && _user.districts.length > 0) {
        this.userDistricts = _user.districts.map((district) => {
          return {
            _id: district._id,
            name: district.name,
          };
        });
      }

      this.userRole = _user.role.name;
    }

    await this.getRoadsData();

    await this.initMap();

    const searchingBar = document.getElementsByClassName(
      "mapboxgl-ctrl-top-right"
    );

    if (searchingBar.length > 0) {
      searchingBar[0].style.display = !this.expandSummary ? "none" : "block";
      this.rightTip = `${
        searchingBar[0].scrollWidth >= 127
          ? 195
          : searchingBar[0].scrollWidth + 38
      }px`;
    }

    await this.getCases();

    await this.getDistricts();

    await this.loadKML();

    await this.addQuarryMarker();

    await this.loadKMLBanjir();
  },
  beforeDestroy() {
    if (this.map) {
      this.map.remove();

      this.map = null;
    }
  },
};
</script>

<style scoped>
.fh-1 {
  font-variant: all-small-caps;
  line-height: initial;
}
</style>
